// Company feature flags returned by GET /auth/permissions (featureFlags),
// resolved by the backend for the logged-in user's company.
export const FEATURE_FLAGS = {
  WEB_FLOW_EDIT: "enabled_see_web_flow_edit",
};

export const hasFeatureFlag = (featureFlags = {}, flag) =>
  !!featureFlags?.[flag];
